/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-07T12:01:47+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AButtonYear from './AButtonYear';
import {cloneDate, addYears} from './dateUtils';

/**
 * MYearCalendar - …
 */
class MYearCalendar extends Component {
  /**
     * react lifecycle componentDidMount() <MYearCalendar>
     *
     * @return {undefined}
     */
  componentDidMount() {
    this.scrollToSelectedYear();
  }

  /**
     * react lifecycle componentDidMount() <MYearCalendar>
     *
     * @return {undefined}
     */
  componentDidUpdate() {
    this.scrollToSelectedYear();
  }

  /**
     * react render() <MYearCalendar>
     *
     * @return {object}
     */
  render() {
    const years = this.getYears();
    return (
      <div
        className="m-year m-year-calendar"
        ref={this.refContainer}
      >
        <div className="m-year-calendar__child">
          {years}
        </div>
      </div>
    );
  }

    /**
     * DOM ref callback for outter container
     *
     * @param {DOMNode} node
     * @return {undefined}
     */
    refContainer = (node) => {
      this._containerNode = node;
    }

    /**
     * DOM ref callback for current year button
     *
     * @param {DOMNode} node
     * @return {undefined}
     */
    refSelectedYearButton = (node) => {
      this._selectedYearNode = node;
    }

    /**
     * handler to catch click onto a year button
     *
     * @param {number} year
     * @param {object} event
     * @return {undefined}
     */
    handleOnPressYear = (year, event) => {
      if (this.props.onPressYear) this.props.onPressYear(year, event);
    }

    /**
     * helper to create array of react elements with available years in
     * year selection element
     *
     * @return {array}
     */
    getYears() {
      const minYear = this.props.minDate.getFullYear();
      const maxYear = this.props.maxDate.getFullYear();

      const years = [];
      const dateCheck = cloneDate(this.props.selectedDate);
      for (let year = minYear; year <= maxYear; year++) {
        dateCheck.setFullYear(year);
        const selected = this.props.selectedDate.getFullYear() === year;

        let yearButton;
        if (selected) {
          yearButton = (
            <span ref={this.refSelectedYearButton} key={`yb${year}`}>
              <AButtonYear
                onPress={this.handleOnPressYear}
                active={selected}
                year={year}
              />
            </span>
          );
        } else {
          yearButton = (
            <AButtonYear
              key={`yb${year}`}
              onPress={this.handleOnPressYear}
              active={selected}
              year={year}
            />
          );
        }
        years.push(yearButton);
      }

      return years;
    }

    /**
     * scroll inside _containerNode to a selected year
     * if we return from dayMonth-view
     *
     * @return {undefined}
     */
    scrollToSelectedYear() {
      if (this._selectedYearNode === undefined) return;

      const container = this._containerNode;
      const yearButtonNode = this._selectedYearNode;

      const containerHeight = container.clientHeight;
      const yearButtonNodeHeight = yearButtonNode.clientHeight || 32;

      const scrollYOffset = (yearButtonNode.offsetTop + yearButtonNodeHeight / 2) - containerHeight / 2;
      container.scrollTop = scrollYOffset;
    }
}
MYearCalendar.propTypes = {
  selectedDate: PropTypes.instanceOf(Date).isRequired,
  maxDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  /**
     * passes the selected (years)
     * @type {Function}
     */
  onPressYear: PropTypes.func,
};
MYearCalendar.defaultProps = {
  selectedDate: new Date(),
  minDate: addYears(new Date(), -5),
  maxDate: addYears(new Date(), 5),
};
export default MYearCalendar;

